import { createContext, useContext } from 'react'

const AppShellContext = createContext({ isShellVisible: true })

export function AppShellProvider({
    isShellVisible,
    children,
}: {
    isShellVisible: boolean
    children: React.ReactNode
}) {
    return (
        <AppShellContext.Provider value={{ isShellVisible }}>
            {children}
        </AppShellContext.Provider>
    )
}

export function useAppShellVisible(): boolean {
    return useContext(AppShellContext).isShellVisible
}
